import { ReactNode } from 'react';
import { CookieConsentContext, useCookieConsentProvider } from '@/hooks/use-cookie-consent';
import { CookieBanner } from './cookie-banner';

export function CookieConsentProvider({ children }: { children: ReactNode }) {
  const value = useCookieConsentProvider();
  return (
    <CookieConsentContext.Provider value={value}>
      {children}
      <CookieBanner />
    </CookieConsentContext.Provider>
  );
}
